export enum ePaymentPeriod {
  annual = 'annual',
  semi_annual = 'semi_annual',
  quarterly = 'quarterly',
  monthly = 'monthly',
}
